import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const ExportQuestion = (questionsList) => {
  // Flatten questions for Excel
  console.log("Exporting questions:", questionsList);
  const data = questionsList.map((q) => {
    const obj = {
        class_id: q.class_id,
        subject_id: q.subject_id,
        chapter_id: q.chapter_id,
        question_type: q.question_type,
        Question: q.question,
    };

    // Fill exactly 4 options, blank if not available
    for (let i = 0; i < 4; i++) {
      obj[`Option_${i + 1}`] = q.options[i]?.option || "";
    }

    // Find correct option index (first one with isCorrect true)
    const correctIndex = q.options.findIndex((o) => o.isCorrect);
    obj["Correct_Option"] = correctIndex >= 0 ? `Option_${correctIndex + 1}` : "";

    return obj;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Questions");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "questions.xlsx");
};
